import { useState } from "react";
import { HeaderLine } from "component/organisms/header-line";
import { PageContainer } from "component/templates/page-container";
import { ZohoAuthProvider } from "context/ZohoAuthContext";
import { Calender } from "component/organisms/calender";
// https://demo.mobiscroll.com/react/eventcalendar/resource-filtering-in-header#

function Route() {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedConfigs, setSelectedConfigs] = useState([]);
  const [selectedView, setSelectedView] = useState(null);

  return (
    <PageContainer
      borderTop
      pageHeader={
        <HeaderLine
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          //
          selectedConfigs={selectedConfigs}
          setSelectedConfigs={setSelectedConfigs}
          //
          selectedView={selectedView}
          setSelectedView={setSelectedView}
        />
      }
    >
      <Calender resources={selectedUsers} selectedSettings={selectedConfigs} selectedView={selectedView} />
    </PageContainer>
  );
}

export function WebtabRoute() {
  return (
    <ZohoAuthProvider>
      <Route />
    </ZohoAuthProvider>
  );
}
